import { logger } from '@/lib/logger'
import { fileService } from '@/services/file.service'

const log = logger.child('articles')

/**
 * Delete the files whose placement the author removed from the body.
 *
 * Called AFTER the save that made the removal real, never on the keystroke that
 * deleted the `<img>`: until the article is stored, the version a reader sees still
 * shows the image, and an undo would put the placement straight back.
 *
 * A failed delete is logged and otherwise swallowed. The article no longer
 * references these files, so the cost is an unreferenced object in the public
 * bucket — not something the author could act on if told, and not a reason to
 * report a save that succeeded as a failure.
 */
export async function discardRemovedImages(fileIds: readonly string[]): Promise<void> {
	if (fileIds.length === 0) return

	const outcomes = await Promise.allSettled(fileIds.map((fileId) => fileService.deleteFile(fileId)))
	const failed = fileIds.filter((_, index) => outcomes[index].status === 'rejected')
	if (failed.length > 0) log.warn('images removed from the body could not be deleted', { failed })
}
